module.exports = __webpack_public_path__ + "static/media/sss-auto-provider.5b92ddbc.svg";